// extracted by mini-css-extract-plugin
export default {"empty":"dropdown_folder_list-module__empty--I1prX","subtitle":"dropdown_folder_list-module__subtitle--3w7-m"};